import { ChevronDown, ChevronUp } from 'lucide-react';
import React, { useCallback } from 'react';

import { IconContainer } from './styles';

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
}

const UDInputNumberControls = (props: Props) => {
  const stepUp = useCallback(() => {
    if (props.inputRef.current) {
      props.inputRef.current.stepUp();
      props.inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, [props.inputRef]);

  const stepDown = useCallback(() => {
    if (props.inputRef.current) {
      props.inputRef.current.stepDown();
      props.inputRef.current.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, [props.inputRef]);

  return (
    <IconContainer className="flex-center number-controls flex-col select-none">
      <ChevronUp size={16} className="cursor-pointer" onClick={stepUp} />
      <ChevronDown size={16} className="cursor-pointer" onClick={stepDown} />
    </IconContainer>
  );
};

export default UDInputNumberControls;
